import { cpf, cnpj } from 'cpf-cnpj-validator';

export function convertStringToCompare(textToConvert) {
  const text = textToConvert ? textToConvert : '';
  const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
  const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
  const p = new RegExp(a.split('').join('|'), 'g')
  return text.toString().toLowerCase().trim()
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
}

export function removeStringSpaces(text = '') {
  return text.replace(/(\r\n|\n|\r)/gm," ");
}

export function hrefMailGenerator(emails, subject, body) {
  const encodedBody = encodeURIComponent(removeStringSpaces(body).trim());
  return `mailto:${emails.join(',')}?subject=${subject}&body=${encodedBody}`;
}

export function increaseDateByDays(date, days) {
  let parsedDate;

  if (typeof date === 'string') {
    const [year, month, day] = date.split('-');

    parsedDate = new Date(year, +month - 1, day);
  } else if (typeof date === 'object') {
    parsedDate = new Date(date);
  }
  
  const parsedDays = +days || 0;

  if (parsedDays === 0 || !parsedDate) return date;

  return new Date().setDate(parsedDate.getDate() + days);
}

export function minutesToMilliseconds(minutes = 0) {
  return 1000 * 60 * minutes;
}

export function hoursToMilliseconds(hours = 0) {
  return 1000 * 60 * 60 * hours;
}

export function cpfIsValid(num) {
  return cpf.isValid(num);
}

export function cnpjIsValid(num) {
  return cnpj.isValid(num)
}

export function formatCpf(num) {
  return cpf.format(num);
}

export function formatCnpj(num) {
  return cnpj.format(num);
}